export default {
   gGet: (state, getters, rootState) => (id) => {
     return state.charts.find(chart => chart.id === id);
   }
}
